module.exports = __webpack_public_path__ + "img/087e46d.png";